module.exports = __webpack_public_path__ + "static/media/20200507-182640-001a.20bf375d.png";